// Configuração das rotas da aplicação
export const ROUTES = {
  DASHBOARD: 'dashboard',
  SEARCH: 'search',
  USERS: 'users',
  COBRANCA: 'cobranca',
  APIS: 'apis',
  REPROCESS: 'reprocess',
  SETTINGS: 'settings',
  MIGRATION: 'migration',
  CSV_IMPORT: 'csv-import',
  TIMELINE: 'timeline'
};

// Configuração das permissões por rota
export const ROUTE_PERMISSIONS = {
  [ROUTES.DASHBOARD]: ['admin'],
  [ROUTES.USERS]: ['admin', 'manager'],
  [ROUTES.SEARCH]: ['admin', 'manager', 'user'],
  [ROUTES.COBRANCA]: ['admin', 'manager', 'user'],
  [ROUTES.APIS]: ['admin', 'manager', 'user'],
  [ROUTES.REPROCESS]: ['admin'],
  [ROUTES.SETTINGS]: ['admin'],
  [ROUTES.MIGRATION]: ['admin', 'manager'],
  [ROUTES.CSV_IMPORT]: ['admin', 'manager'],
  [ROUTES.TIMELINE]: ['admin', 'manager', 'user']
};

// Configuração das views iniciais por role
export const INITIAL_VIEWS = {
  admin: ROUTES.DASHBOARD,
  manager: ROUTES.SEARCH,
  user: ROUTES.SEARCH
};

// Configuração dos títulos das páginas
export const PAGE_TITLES = {
  [ROUTES.DASHBOARD]: 'Dashboard',
  [ROUTES.SEARCH]: 'Consulta de Dados',
  [ROUTES.USERS]: 'Gerenciamento de Usuários',
  [ROUTES.COBRANCA]: 'Nova Cobrança',
  [ROUTES.APIS]: 'Status das APIs',
  [ROUTES.REPROCESS]: 'Reprocessar JSON',
  [ROUTES.SETTINGS]: 'Configurações',
  [ROUTES.MIGRATION]: 'Migração',
  [ROUTES.CSV_IMPORT]: 'Importar CSV',
  [ROUTES.TIMELINE]: 'Timeline Bitrix'
};

// Configuração das descrições das páginas
export const PAGE_DESCRIPTIONS = {
  [ROUTES.DASHBOARD]: 'Visão geral do sistema e status das APIs',
  [ROUTES.SEARCH]: 'Busque e consulte informações em todas as APIs do sistema',
  [ROUTES.USERS]: 'Gerencie usuários, permissões e configurações do sistema',
  [ROUTES.COBRANCA]: 'Crie uma nova cobrança no sistema com todos os detalhes necessários',
  [ROUTES.APIS]: 'Monitore o status e performance de todas as APIs do sistema',
  [ROUTES.REPROCESS]: 'Envie JSONs para reprocessamento no servidor externo',
  [ROUTES.SETTINGS]: 'Configure as preferências e configurações do sistema',
  [ROUTES.MIGRATION]: 'Busque e exporte negócios do Bitrix24 para migração',
  [ROUTES.CSV_IMPORT]: 'Importe negócios de CSV exportado do Bitrix antigo para o novo',
  [ROUTES.TIMELINE]: 'Visualize atividades, comentários e tarefas de deals do Bitrix24'
};

